export const DEFAULT_INTERLAYER_NAME_RE = /^interlayer\s*(\d+)$/i;

export const PALLET_INTERLAYER_NAME_KEY = 'pallet_interlayer_name';

export function parseDefaultInterlayerNumber(name: string | undefined | null): number | null {
  const match = DEFAULT_INTERLAYER_NAME_RE.exec((name ?? '').trim());
  return match ? parseInt(match[1], 10) : null;
}

/** Maps stored/API name to a value suitable for the name input (canonical `interlayer N` → localized default). */
export function interlayerNameForFormInput(
  name: string | undefined | null,
  instant?: (key: string, params?: Record<string, unknown>) => string,
): string {
  const raw = (name ?? '').trim();
  if (!raw) {
    return '';
  }
  const n = parseDefaultInterlayerNumber(raw);
  if (n !== null && instant) {
    return formatDefaultInterlayerName(n, instant);
  }
  return raw;
}

/** Normalizes form input back to canonical `interlayer N` when it matches a default (localized) name. */
export function canonicalInterlayerNameForSave(
  rawName: string | undefined | null,
  instant: (key: string, params?: Record<string, unknown>) => string,
  maxDefaultIndex = 200,
): string | null {
  const raw = (rawName ?? '').trim();
  if (!raw) {
    return null;
  }
  const n = parseDefaultInterlayerNumber(raw);
  if (n !== null) {
    return `interlayer ${n}`;
  }
  for (let i = 1; i <= maxDefaultIndex; i++) {
    if (raw === formatDefaultInterlayerName(i, instant)) {
      return `interlayer ${i}`;
    }
  }
  return raw;
}

export function formatDefaultInterlayerName(
  n: number,
  instant: (key: string, params?: Record<string, unknown>) => string,
): string {
  const translated = instant(PALLET_INTERLAYER_NAME_KEY, { n });
  return translated === PALLET_INTERLAYER_NAME_KEY ? `Przekładka ${n}` : translated;
}

/** Maps stored/API name to localized label (canonical `interlayer N` → translated default name). */
export function resolveInterlayerDisplayName(
  rawName: string | undefined | null,
  instant: (key: string, params?: Record<string, unknown>) => string,
  options?: { fallbackIndex?: number; emptyFallbackKey?: string },
): string {
  const raw = rawName?.trim();
  if (raw) {
    const n = parseDefaultInterlayerNumber(raw);
    if (n !== null) {
      return formatDefaultInterlayerName(n, instant);
    }
    const looksLikeI18nKey = /^[a-z][a-z0-9_]*$/i.test(raw);
    if (!looksLikeI18nKey) {
      const translated = instant(raw);
      return translated !== raw ? translated : raw;
    }
  }
  if (options?.fallbackIndex != null) {
    return formatDefaultInterlayerName(options.fallbackIndex, instant);
  }
  if (options?.emptyFallbackKey) {
    return instant(options.emptyFallbackKey);
  }
  return '';
}
